<template>
    <v-container>
        <div>
            <v-alert
                    id="alertComp"
                    v-model="alert"
                    dismissible
                    type="success"
            >
                Proceso de exportación creado exitosamente.
            </v-alert>
        </div>
        <v-layout>
            <v-flex xs12 sm8 offset-sm2>
                <v-card color="secondary" dark>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline">Descarga de datos PACIENTES HCU (Formato Excel)</h3>
                            <div>
                                <strong>Recuerde!...</strong> Este proceso analiza la informacion historia clínica
                                unica, <br>
                                segun la seleccion de los parametros en el siguiente orden:<br>
                                <strong>1.</strong> Verifica si existen hojas de ruta CERRADAS en el rango de fecha
                                seleccionado paciente por paciente.<br>
                                <strong>2.</strong> Luego procede a analizar solo los pacientes que tienen hojas de ruta
                                cerradas en el siguiente orden:<br>
                                <strong>1.</strong> Anamnesis.
                                <strong>2.</strong> Oftalmologia.
                                <strong>3.</strong> Audiologia.
                                <strong>4.</strong> Anexo de salud y trabajo.
                                <strong>5.</strong> Archivos anexos.
                                <strong>6.</strong> Mediciones.
                            </div>
                        </div>
                    </v-card-title>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                >
                    <v-select
                            v-model="idCliente"
                            :items="$store.state.companies"
                            item-value="id"
                            item-text="name"
                            :rules="[v => !!v || 'Cliente es requerido']"
                            label="Cliente"
                            required
                    ></v-select>

                    <v-select
                            v-model="idTipoExamen"
                            :items="tipoExamenItems"
                            :rules="[v => !!v || 'Tipo examen es requerido']"
                            label="Tipo examen"
                            required
                    ></v-select>

                    <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="fechaInicio"
                                    label="Fecha inicio"
                                    readonly
                                    v-on="on"
                                    required
                                    :rules="[v => !!v || 'Fecha inicio es requerida']"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaInicio" @input="menu = false"></v-date-picker>
                    </v-menu>

                    <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="fechaFin"
                                    label="Fecha fin"
                                    readonly
                                    v-on="on"
                                    required
                                    :rules="[v => !!v || 'Fecha fin es requerida']"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaFin" @input="menu2 = false"></v-date-picker>
                    </v-menu>

                    <v-select
                            v-model="idAgencia"
                            :items="$store.state.companyAgencies"
                            item-value="id"
                            item-text="name"
                            :rules="[v => !!v || 'Agencia es requerida']"
                            label="Sucursal/agencia/planta"
                            required
                    ></v-select>

                    <v-select
                            v-model="idPuestoTrabajo"
                            :items="$store.state.companyJobs"
                            item-value="id"
                            item-text="name"
                            :rules="[v => !!v || 'Puesto de trabajo es requerido']"
                            label="Puesto de trabajo"
                            required
                    ></v-select>
                    <v-btn color="primary"
                           dark
                           @click="newConfiguration">Configurar Campos
                    </v-btn>

                </v-form>
                <div class="text-xs-center">
                    <v-btn color="primary"
                           dark
                           @click="save">Guardar
                    </v-btn>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    fullscreen hide-overlay transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Configuración Campos Reporte</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <h3 class="primary--text">Lista de Campos</h3>
                            <v-data-table
                                    :headers="headers"
                                    :items="this.dataExport"
                                    :search="search"
                                    hide-default-footer
                                    class="elevation-1"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">{{ props.item.id }}</td>
                                    <td class="text-xs-left">{{ props.item.name }}</td>
                                    <td class="text-xs-left">
                                        <v-text-field
                                                label="Nuevo Nombre"
                                                v-model="props.item.newName"
                                        ></v-text-field>
                                    </td>
                                    <td class="text-xs-left">
                                        <v-checkbox
                                                v-model="props.item.selected"
                                                label="Seleccione"
                                        ></v-checkbox>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>

                        </v-form>
                        <div class="text-xs-center">
                            <v-btn color="primary" @click="saveConfiguration" dark>Guardar</v-btn>
                        </div>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>
<script>
    import CompanyJob from "../company/companyJob/CompanyJob";

    export default {
        data() {
            return {
                idCliente: '',
                valid: true,
                tipoExamenItems: ['TODOS',
                    'PREOCUPACIONAL',
                    'INICIAL',
                    'PERIÓDICO',
                    'REUBICACIÓN',
                    'ESPECIAL',
                    'RETIRO',
                    'REINSERCIÓN'],
                idTipoExamen: '',
                fechaInicio: '',
                fechaFin: '',
                menu: false,
                menu2: false,
                idAgencia: '',
                idPuestoTrabajo: '',
                alert: false,
                dialog: false,
                search: "",
                idConfiguration: "",
                headers: [
                    {text: 'Número', value: 'id'},
                    {text: 'Nombre', value: 'name'},
                    {text: 'Nuevo nombre', value: 'newName'},
                    {text: 'Selección', value: 'selected'},
                ],
                campos: ['APELLIDO PAT',
                    'APELLIDO MAT',
                    'NOMBRE1',
                    'NOMBRE2',
                    'CED',
                    'FECHA NACIMIENTO',
                    'EDAD',
                    'GRUPO EDAD',
                    'SEXO',
                    'SEXO TXT',
                    'PESO',
                    'TALLA',
                    'IMC CORP',
                    'EMPRESA',
                    'PUESTO',
                    'PUESTO TXT',
                    'TIPO PUESTO',
                    'TIPO PUESTO TXT',
                    'PLANTA',
                    'PLANTA TXT',
                    'CENTRO COSTO',
                    'ESCOLARIDAD',
                    'TIPO EXAM',
                    'R SOCIAL',
                    'R FAMILIAR',
                    'DIAG CAP1',
                    'DIAG CAP2',
                    'DIAG CAP3',
                    'DIAG CAP4',
                    'DIAG CAP5',
                    'DIAG CAP6',
                    'DIAG CAP7',
                    'DIAG CAP8',
                    'DIAG CAP9',
                    'DIAG CAP10',
                    'DIAG CAP11',
                    'DIAG CAP12',
                    'DIAG CAP13',
                    'DIAG CAP14',
                    'DIAG CAP15',
                    'DIAG CAP16',
                    'DIAG CAP17',
                    'DIAG CAP18',
                    'DIAG CAP19',
                    'DIAG CAP20',
                    'DIAG CAP21',
                    'DIAG CAPINSC',
                    'SD METAB',
                    'FRM RIESGO ESTIMADO',
                    'FRM RIESGO ESTIMADO TXT',
                    'MANIF TEMP',
                    'ME CARDIOV',
                    'ME OSTEOM',
                    'ME DERMAT',
                    'ME NUTRIC',
                    'ME RESP',
                    'ME AUDIT',
                    'ME MENTAL',
                    'ME OFTAL',
                    'DIAG REFRAC 1',
                    'DIAG REFRAC 2',
                    'DIAG PATOL',
                    'TEST DE ISHIHARA',
                    'TEST DE TITMUS',
                    'DIAG AUDIOGRL',
                    'DIAG AUDIOGRL TXT',
                    'AUTOMEDI',
                    'MED DORMIR',
                    'ANTIDEPRES',
                    'FUMA',
                    'FUMABA',
                    'TIEMPO FUMAR',
                    'FUM PASIVO',
                    'THINER GASO',
                    'ALCOHOL',
                    'FREC ALCOHOL',
                    'EMBRIAGARSE',
                    'CIBERDEP',
                    'DEPORTE',
                    'LESIONES DEP',
                    'TURNO',
                    'POSTURA PRED',
                    'ANTIGUEDAD',
                    'DUR JORNADA',
                    'DIAS TRABAJO',
                    'DIAS DESCANSO',
                    'TIPO CONTRATO',
                    'PP MECANICOS',
                    'ESPACIO FÍSICO REDUCIDO',
                    'PISO IRREGULAR, RESB.',
                    'OBSTÁCULOS EN EL PISO',
                    'DESORDEN',
                    'MAQ.DESPROT',
                    'MANEJO HERRAMIENTA CORT',
                    'CIRCULACIÓN DE MAQUINARIA Y VEHÍCULOS EN ÁREA',
                    'DESPLAZAMIENTO TRANSP ',
                    'TRANSPORTE MECÁNICO DE CARGAS',
                    'TRAB. DISTINTO NIVEL',
                    'TRAB. SUBTERRANEO',
                    'TRAB. ALTURA',
                    'CAIDA DE OBJETOS',
                    'ESTIBA INADECUADA',
                    'PROY. SOLIDOS-LIQUIDOS',
                    'SUPERF. CALIENTES',
                    'TRAB. CONFINADO',
                    'GRADAS Y ESCALERAS',
                    'PP FISICOS',
                    'TEMP. ELEVADA',
                    'TEMP. BAJA',
                    'ILUMINACION INSUFIC.',
                    'ILUMINACION EXCES.',
                    'RUIDO',
                    'VIBRAC.',
                    'RAD. IONIZ',
                    'RAD.NO IONIZ',
                    'PRESION ANORMAL',
                    'VENT.INSUF.',
                    'MAN.ELEC.INADEC.',
                    'PP QUÍMICOS',
                    'POLVO ORGANICO',
                    'POLVO INORGANICO',
                    'GASES',
                    'VAPORES',
                    'NIEBLAS',
                    'SMOG',
                    'MANIPULACION QUIMICOS',
                    'PP BIOLÓGICOS',
                    'ELEM. DESCOMP.',
                    'ANIMALES PELIGROSOS',
                    'ANIAMLES VENENOSOS',
                    'VECTORES',
                    'ALIMENTOS NO GARANTIZADOS',
                    'ALERGENOS',
                    'BACTERIAS, VIRUS,HONGOS',
                    'PP ERGONÓMICOS',
                    'SOBRESFUERZO',
                    'LEVANT CARGAS',
                    'MOV REPETIT',
                    'POST FORZADA',
                    'PVDS',
                    'EMP. Y TRACCION',
                    'PP PSICOSOCIALES',
                    'TURNOS ROTATIVOS',
                    'TRAB.NOCTURNO',
                    'TRAB. PRESION',
                    'ALTA RESPONSAB.',
                    'MINUCIOSIDAD',
                    'TRAB. MONOTONO',
                    'INESTABILIDAD',
                    'DEFICIT COMUNIC',
                    'INADECUADA SUPERV',
                    'RELAC. INTERPERSONAL MALA',
                    'DESARRAIGO',
                    'MALTRATO',
                    'MALTRATO CLIENTES',
                    'AMENAZA DELINCUEN',
                    'PP MAYORES',
                    'INFLAM. -EXPLOSIV',
                    'ELEMENT. PRESION',
                    'SISTE.ELECTRIC. DEFEC.',
                    'PUNTOS IGNICION',
                    'ALMACENAJ QUIMICOS',
                    'DEPÓSITO Y ACUMULACIÓN DE POLVO',
                    'CARGA COMBUSTIBLE',
                    'ZONAS RIESGO-DESASTRES',
                    'ACCIDENTES TRAB',
                    'INCAPACIDAD',
                    'ENFERMEDAD TRAB',
                    'PENSAR Y ACTUAR',
                    'DESARROLLO FIS Y MENT',
                    'COMPAÑERISMO',
                    'SOLIDARIDAD',
                    'VARIACION ACTIVI',
                    'CREATIVIDAD',
                    'VALORACION COMPAÑEROS',
                    'VALORACIÓN JEFES',
                    'CAPACITACION',
                    'GIMNASIOS',
                    'TALLERES RECREA',
                    'CLUBES',
                    'TRAB COMUNITARIO',
                    'SALARIO JUSTO',
                    'PROG RECREATI',
                    'TURISMO',
                    'COMEDOR',
                    'MANEJO DE HERRAMIENTA CORTANTE Y/O PUNZANTE',
                    'GUARDERÍA',
                    'CENTRO EDUC',
                    'SATISFACCION TAREA',
                    'DESARR INICIATI',
                    'DESARR HABILI',
                    'ADQUI CONOCI',
                    'DESARROLLO FISICO',
                    'ALEGRIA',
                    'SOLIDARIO',
                    'ECO ABDO',
                    'ECO ABDO TXT',
                    'RX COLUMNA',
                    'RX COLUMNA TXT',
                    'RX TORAX',
                    'RX TORAX TXT',
                    'LAB CLIN',
                    'LAB CLIN TXT',
                    'ESPIRO',
                    'ERGOMETRÍA',
                    'PLIEGUES',
                    'EQUILIBRIO',
                    'EQUILIBRIO TXT',
                    'ECG',
                    'ECG TXT',
                    'EEG',
                    'EEG TXT',
                    'TEST FOBIA ALTURA',
                    'TEST FOBIA ESPACIOS CONFINADOS',
                    'SONOMETRIA',
                    'DOSIMETRIA',
                    'VIBRACION',
                    'TEMPERATURA',
                    'ILUMINACION',
                    'PARTICULADO',
                    'STS OI',
                    'STS OD',
                    'USA LENTES',
                    'COLESTEROL',
                    'TRIGLICERIDOS',
                    'GLUCOSA',
                    'HDL',
                    'PAS',
                    'PAD',
                    'SANGRE',
                    'ANT PER ITEM 13',
                    'REV SIST ITEM 7',
                    'EX FIS ITEM 12R',
                    'EX FIS ITEM 14R',
                    'EX FIS ITEM 15R',
                    'EX FIS ITEM 7S',
                    'ANT PER TXT',
                    'REV SIST TXT',
                    'EX FIS TXT',
                    'MANIFEST. TEMP',
                    'MT CARDIO',
                    'MT OSTEO',
                    'MT DERMA',
                    'MT NUTRI',
                    'MT RESP',
                    'MT AUDIO',
                    'MT SM',
                    'MT OFTA',
                    'DIABETES',
                    'TEST ESFUERZO',
                    'TEST ESFUERZO TXT',
                    'EPIAUD1B',
                    'EPIAUD1C',
                    'EPIAUD1D',
                    'EPIAUD1E',
                    'EPIAUD1F',
                    'EPIAUD1G',
                    'EPIAUD1H',
                    'EPIAUD1I',
                    'EPIAUD2A',
                    'EPIAUD2B',
                    'EPIAUD2C',
                    'EPIAUD2D',
                    'EPIAUD2E',
                    'EPIAUD2F',
                    'EPIAUD2G',
                    'EPIAUD2H',
                    'EPIAUD31',
                    'EPIAUD32',
                    'EPIAUD33',
                    'EPIAUD33TXT',
                    'EPIAUD34',
                    'EPIAUD34TXT',
                    'EPIAUD4A',
                    'EPIAUD4B',
                    'EPIAUD5A',
                    'EPIAUD5A1',
                    'EPIAUD5A2',
                    'EPIAUD5A3',
                    'EPIAUD5A4',
                    'EPIAUD5A5',
                    'EPIAUD5B',
                    'EPIAUD5C',
                    'EPIAUD5D',
                    'EPIAUD5E',
                    'EPIAUD5F',
                    'EPIAUD5G',
                    'EPIAUD5H',
                    'EPIAUD5I',
                    'EPIAUD5J',
                    'EPIAUD5K',
                    'EPIAUD5L',
                    'EPIAUD6A',
                    'EPIAUD6B',
                    'EPIAUD6C',
                    'EPIAUD6D',
                    'EPIAUD6E',
                    'EPIAUD6F',
                    'EPIAUD6G',
                    'EPIAUD7',
                    'EPIAUD8A',
                    'EPIAUD8B',
                    'EPIAUD9A',
                    'EPIAUD9B',
                    'EPIAUD9C',
                    'EPIAUD10',
                    'EPIAUD11',
                    'EPIRESP1B',
                    'EPIRESP1C1',
                    'EPIRESP1C2',
                    'EPIRESP1C3',
                    'EPIRESP1C4',
                    'EPIRESP1C5',
                    'EPIRESP1C6',
                    'EPIRESP1C7',
                    'EPIRESP1C8',
                    'EPIRESP1C9',
                    'EPIRESP1C10',
                    'EPIRESP1C11',
                    'EPIRESP1C12',
                    'EPIRESP1D',
                    'EPIRESP1E',
                    'EPIRESP1F1',
                    'EPIRESP1F2',
                    'EPIRESP1F3',
                    'EPIRESP1F4',
                    'EPIRESP1G',
                    'EPIRESP1H',
                    'EPIRESP1I',
                    'EPIRESP1J',
                    'EPIRESP1K',
                    'EPIRESP1L1',
                    'EPIRESP1L2',
                    'EPIRESP1L3',
                    'EPIRESP1L4',
                    'EPIRESP1M',
                    'EPIRESP1N',
                    'EPIRESP1O',
                    'EPIRESP2A',
                    'EPIRESP2B',
                    'EPIRESP2C',
                    'EPIRESP2D',
                    'EPIRESP2E',
                    'EPIRESP2F',
                    'EPIRESP2G',
                    'EPIRESP2H',
                    'EPIRESP2HTXT',
                    'EPIRESP2I',
                    'EPIRESP2ITXT',
                    'EPIRESP3A',
                    'EPIRESP3B',
                    'EPIRESP3C',
                    'EPIRESP3D',
                    'EPIRESP4A',
                    'EPIRESP4ATXT',
                    'EPIRESP4B',
                    'EPIRESP4BTXT',
                    'EPIRESP4C',
                    'EPIRESP4CTXT',
                    'EPIRESP4D',
                    'EPIRESP4DTXT',
                    'EPIRESP4DTXT2',
                    'EPIRESP5A',
                    'EPIRESP5A1',
                    'EPIRESP5A2',
                    'EPIRESP5A3',
                    'EPIRESP5A4',
                    'EPIRESP5B',
                    'EPIRESP5B1',
                    'EPIRESP5B2',
                    'EPIRESP5B3',
                    'EPIRESP5B4',
                    'EPIRESP5C',
                    'EPIRESP5C1',
                    'EPIRESP5D',
                    'EPIRESP5E',
                    'EPIRESP5F',
                    'EPIRESP5G',
                    'EPIRESP5H',
                    'EPIRESP5I',
                    'EPIRESP5J',
                    'EPIRESP6A',
                    'EPIRESP6B',
                    'EPIRESP6C',
                    'EPIRESP7',
                    'EPIRESP7TXT',
                    'EPIRESP8',
                    'EPIRESP8TXT',
                    'EPIRESP9',
                    'EPIRESP9TXT',
                    'EPIRESP10A',
                    'EPIRESP10B',
                    'EPIRESP10C',
                    'EPIRESP10D',
                    'EPIRESP11',
                    'EPIRESP12',
                    'EPIDERM1B',
                    'EPIDERM1BTXT',
                    'EPIDERM1C',
                    'EPIDERM1D1',
                    'EPIDERM1D2',
                    'EPIDERM1D3',
                    'EPIDERM1D4',
                    'EPIDERM1D5',
                    'EPIDERM1E1',
                    'EPIDERM1E2',
                    'EPIDERM1E3',
                    'EPIDERM1E4',
                    'EPIDERM1E5',
                    'EPIDERM1E6',
                    'EPIDERM1F',
                    'EPIDERM1G1',
                    'EPIDERM1G2',
                    'EPIDERM1G3',
                    'EPIDERM1G4',
                    'EPIDERM1G5',
                    'EPIDERM1G6',
                    'EPIDERM1H',
                    'EPIDERM1I',
                    'EPIDERM1J',
                    'EPIDERM2A',
                    'EPIDERM2B1',
                    'EPIDERM2B2',
                    'EPIDERM2B3',
                    'EPIDERM2B4',
                    'EPIDERM2B5',
                    'EPIDERM2B6',
                    'EPIDERM2C',
                    'EPIDERM2D1',
                    'EPIDERM2D2',
                    'EPIDERM2E',
                    'EPIDERM2F',
                    'EPIDERM2G',
                    'EPIDERM2H',
                    'EPIDERM3A',
                    'EPIDERM3B1',
                    'EPIDERM3B2',
                    'EPIDERM3C',
                    'EPIDERM3D1',
                    'EPIDERM3D2',
                    'EPIDERM4A',
                    'EPIDERM4B',
                    'EPIDERM4C',
                    'EPIDERM4CTXT',
                    'EPIDERM4D',
                    'EPIDERM4E',
                    'EPIDERM4F',
                    'EPIDERM4G',
                    'EPIDERM4H',
                    'EPIDERM4I',
                    'EPIDERM4J',
                    'EPIDERM4K',
                    'EPIDERM5A1',
                    'EPIDERM5A2',
                    'EPIDERM5A3',
                    'EPIDERM5A4',
                    'EPIDERM5A5',
                    'EPIDERM5B',
                    'EPIDERM5C',
                    'EPIDERM5D',
                    'EPIDERM5E',
                    'EPIDERM5F',
                    'EPIDERM6A',
                    'EPIDERM6B',
                    'EPIDERM6C',
                    'EPIDERM7',
                    'EPIDERM8',
                    'EPITME1B',
                    'EPITME1C1',
                    'EPITME1C2',
                    'EPITME1C3',
                    'EPITME1C4',
                    'EPITME1C5',
                    'EPITME1D',
                    'EPITME1E1',
                    'EPITME1E2',
                    'EPITME1E3',
                    'EPITME1E4',
                    'EPITME1E5',
                    'EPITME1F',
                    'EPITME1G',
                    'EPITME1H',
                    'EPITME1I',
                    'EPITME1J',
                    'EPITME1K',
                    'EPITME1L1',
                    'EPITME1L2',
                    'EPITME1L3',
                    'EPITME1L4',
                    'EPITME1L5',
                    'EPITME1L6',
                    'EPITME1M1',
                    'EPITME1M2',
                    'EPITME1M3',
                    'EPITME1M4',
                    'EPITME1M5',
                    'EPITME1M6',
                    'EPITME2A',
                    'EPITME2B',
                    'EPITME2C',
                    'EPITME2D',
                    'EPITME2E',
                    'EPITME2F',
                    'EPITME2G',
                    'EPITME2H',
                    'EPITME2HTXT',
                    'EPITME2I',
                    'EPITME2ITXT',
                    'EPITME3A',
                    'EPITME3B',
                    'EPITME3C',
                    'EPITME3D',
                    'EPITME4A',
                    'EPITME4ATXT',
                    'EPITME4B',
                    'EPITME4BTXT',
                    'EPITME4C',
                    'EPITME4CTXT',
                    'EPITME4D',
                    'EPITME4DTXT',
                    'EPITME5A1',
                    'EPITME5A2',
                    'EPITME5A3',
                    'EPITME5A4',
                    'EPITME5A5',
                    'EPITME5A6',
                    'EPITME5A7',
                    'EPITME5A8',
                    'EPITME5A9',
                    'EPITME5A10',
                    'EPITME5A11',
                    'EPITME5A12',
                    'EPITME5B',
                    'EPITME5C',
                    'EPITME5C1',
                    'EPITME5C2',
                    'EPITME5D',
                    'EPITME5E',
                    'EPITME5F',
                    'EPITME5G',
                    'EPITME5H',
                    'EPITME6',
                    'EPITME7',
                    'EPITME8A',
                    'EPITME8B',
                    'EPITME8C',
                    'EPITME9',
                    'EPITME9TXT',
                    'EPITME10',
                    'EPITME10TXT',
                    'EPITME11',
                    'EPITME11TXT',
                    'EPITME12',
                    'EPITME12TXT',
                    'EPITME13',
                    'EPITME14',
                    'EPITME15',
                    'EPIOFTA1B',
                    'EPIOFTA1C',
                    'EPIOFTA1D',
                    'EPIOFTA1E',
                    'EPIOFTA1F',
                    'EPIOFTA1G',
                    'EPIOFTA1H',
                    'EPIOFTA1I',
                    'EPIOFTA1J',
                    'EPIOFTA1JTXT',
                    'EPIOFTA1K',
                    'EPIOFTA1L',
                    'EPIOFTA2A',
                    'EPIOFTA2B',
                    'EPIOFTA2C1',
                    'EPIOFTA2C2',
                    'EPIOFTA2D',
                    'EPIOFTA2E',
                    'EPIOFTA2F',
                    'EPIOFTA2FTXT',
                    'EPIOFTA2G',
                    'EPIOFTA2H',
                    'EPIOFTA2I',
                    'EPIOFTA2J',
                    'EPIOFTA2K',
                    'EPIOFTA3A',
                    'EPIOFTA3B',
                    'EPIOFTA3C',
                    'EPIOFTA3D',
                    'EPIOFTA4A',
                    'EPIOFTA4B',
                    'EPIOFTA4C',
                    'EPIOFTA4D',
                    'EPIOFTA5A',
                    'EPIOFTA5B',
                    'EPIOFTA5C',
                    'EPIOFTA5D',
                    'EPIOFTA5E',
                    'EPIOFTA5F',
                    'EPIOFTA5G',
                    'EPIOFTA5H',
                    'EPIOFTA5I',
                    'EPIOFTA5J',
                    'EPIOFTA5K',
                    'EPIOFTA5L',
                    'EPIOFTA5M',
                    'EPIOFTA5N',
                    'EPIOFTA5O',
                    'EPIOFTA6',
                    'EPIOFTA6TXT',
                    'EPIOFTA7A',
                    'EPIOFTA7B',
                    'EPIOFTA8',
                    'EPIOFTA9',
                    'EPINUTRI2A',
                    'EPINUTRI2B',
                    'EPINUTRI2C',
                    'EPINUTRI2D',
                    'EPINUTRI2E1',
                    'EPINUTRI2E2',
                    'EPINUTRI2E3',
                    'EPINUTRI2E4',
                    'EPINUTRI2E5',
                    'EPINUTRI2E6',
                    'EPINUTRI2E7',
                    'EPINUTRI2E8',
                    'EPINUTRI2E8TXT',
                    'EPINUTRI2F',
                    'EPINUTRI2FTXT',
                    'EPINUTRI2G',
                    'EPINUTRI2H',
                    'EPINUTRI2I',
                    'EPINUTRI2J',
                    'EPINUTRI2JTXT',
                    'EPINUTRI2K',
                    'EPINUTRI2L',
                    'EPINUTRI2LTXT',
                    'EPINUTRI2M',
                    'EPINUTRI2MTXT',
                    'EPINUTRI2N',
                    'EPINUTRI2NTXT',
                    'EPINUTRI3A',
                    'EPINUTRI3B',
                    'EPINUTRI3C',
                    'EPINUTRI3CTXT',
                    'EPINUTRI4A',
                    'EPINUTRI4B1',
                    'EPINUTRI4B2',
                    'EPINUTRI4B3',
                    'EPINUTRI4C',
                    'EPINUTRI4CTXT',
                    'EPINUTRI4D',
                    'EPINUTRI4DTXT',
                    'EPINUTRI5A',
                    'EPINUTRI5B',
                    'EPINUTRI5C',
                    'EPINUTRI5D',
                    'EPINUTRI5E',
                    'EPINUTRI5ETXT',
                    'EPINUTRI5F',
                    'EPINUTRI5G',
                    'EPINUTRI5GTXT',
                    'EPINUTRI5H',
                    'EPINUTRI5HTXT',
                    'EPINUTRI5I1',
                    'EPINUTRI5I2',
                    'EPINUTRI5I3',
                    'EPINUTRI5I4',
                    'EPINUTRI5I5',
                    'EPINUTRI5I5TXT',
                    'EPINUTRI5J',
                    'EPINUTRI5K',
                    'EPINUTRI5L',
                    'EPINUTRI5M',
                    'EPINUTRI5N',
                    'EPINUTRI5O',
                    'EPINUTRI5OTXT',
                    'EPINUTRI5P',
                    'EPINUTRI5PTXT',
                    'EPINUTRI5Q',
                    'EPINUTRI5QTXT',
                    'EPINUTRI5R',
                    'EPINUTRI5S1',
                    'EPINUTRI5S2',
                    'EPINUTRI5S3',
                    'EPINUTRI5S4',
                    'EPINUTRI6A',
                    'EPINUTRI6B1',
                    'EPINUTRI6B2',
                    'EPINUTRI6B3',
                    'EPINUTRI6B4',
                    'EPINUTRI6C11',
                    'EPINUTRI6C12',
                    'EPINUTRI6C13',
                    'EPINUTRI6C14',
                    'EPINUTRI6C21',
                    'EPINUTRI6C22',
                    'EPINUTRI6C23',
                    'EPINUTRI6C24',
                    'EPINUTRI6C31',
                    'EPINUTRI6C32',
                    'EPINUTRI6C33',
                    'EPINUTRI6C34',
                    'EPINUTRI6C41',
                    'EPINUTRI6C42',
                    'EPINUTRI6C43',
                    'EPINUTRI6C44',
                    'EPINUTRI6D',
                    'EPINUTRI6E',
                    'EPINUTRI7',
                    'EPINUTRI8',
                    'EPINEGDQUIMICO',
                    'EPINEGDTIPO',
                    'EPINEGDCAS',
                    'EPINEGDSEVERIDAD',
                    'EPINEGDPARTE',
                    'EPINEGDTIEMPO',
                    'EPINEGDCALCULO',
                    'EPICRIAUDTABLA1',
                    'EPICRIAUDTABLA2',
                    'EPICRIAUDTABLA3',
                    'EPICRIAUDTABLA4',
                    'EPICRIAUDTABLA5',
                    'EPICRIAUDTABLA6',
                    'EPICRIAUDTABLA7',
                    'EPICRIRESPTABLA1',
                    'EPICRIRESPTABLA2',
                    'EPICRIRESPTABLA3',
                    'EPICRIRESPTABLA4',
                    'EPICRIRESPTABLA5',
                    'EPICRIRESPTABLA6',
                    'EPICRIRESPTABLA7',
                    'EPICRIDERMTABLA1',
                    'EPICRIDERMTABLA2',
                    'EPICRIDERMTABLA3',
                    'EPICRIDERMTABLA4',
                    'EPICRIDERMTABLA5',
                    'EPICRIDERMTABLA6',
                    'EPICRIDERMTABLA7',
                    'EPICRITMETABLA1',
                    'EPICRITMETABLA2',
                    'EPICRITMETABLA3',
                    'EPICRITMETABLA4',
                    'EPICRITMETABLA5',
                    'EPICRITMETABLA6',
                    'EPICRITMETABLA7',
                    'EPICRIOFTTABLA1',
                    'EPICRIOFTTABLA2',
                    'EPICRIOFTTABLA3',
                    'EPICRIOFTTABLA4',
                    'EPICRIOFTTABLA5',
                    'EPICRIOFTTABLA6',
                    'EPICRIOFTTABLA7',
                    'ORL',
                    'ECOCARDIO',
                    'IC CARDIO',
                    'ECOPROST',
                    'ECOTIR',
                    'ECOPELV',
                    'PAPTEST',
                    'MAMOG',
                    'DENSITO',
                    'Q16',
                    'DASH1',
                    'DASH2',
                    'MORRIS',
                    'OSDI',
                    "ACCIDENTE DE TRABAJO",
                    "ALCOHOL EN SANGRE",
                    "ANAMNESIS Y EXAMEN FÍSICO",
                    "ANTÍGENO PROSTÁTICO ESPECÍFICO",
                    "ANTROPOMETRIA",
                    "ANTROPOMETRIA Y SUMA DE PLIEGUES",
                    "AUDIOMETRÍA DE OCTAVAS ",
                    "AUDIOMETRIA DE OCTAVAS Y VALORACIÓN DE ORL ",
                    "AUDIOMETRÍA TONAL E IMPEDANCIOMETRÍA",
                    "BTX",
                    "CA 125",
                    "CERTIFICADO IESS",
                    "CERTIFICADO MÉDICO",
                    "CERTIFICADO MEDICO DE ESPECIALIDAD",
                    "CERTIFICADOS LAB EXTERNOS",
                    "CHEQUEO GINECOLOGICO",
                    "COPRO",
                    "CUESTIONARIO DE FOBIAS",
                    "CUESTIONARIO NORDICO",
                    "DENSITOMETRÍA OSEA",
                    "E DERMATOLOGICO",
                    "ECO ABDOMINAL INFERIOR",
                    "ECO ABDOMEN SUPERIOR",
                    "ECO DE CUELLO",
                    "ECO DE PRÓSTATA",
                    "ECO MAMARIO",
                    "ECO PÉLVICO",
                    "ECO PROSTÁTICO",
                    "ECO TIROIDEO",
                    "ECO-CARDIOGRAMA",
                    "ELECTROCARDIOGRAMA EN REPOSO",
                    "ELECTROENCEFALOGRAMA",
                    "ENDOSCOPIA",
                    "ERGOTEST",
                    "ESPIROMETRÍA",
                    "ESTUDIO ERGONOMICO DE PUESTO DE TRABAJO",
                    "EVALUACIÓN CARDIOLOGICA Y NUTRICIONAL",
                    "EVALUACIÓN FISIOTERAPÉUTICA",
                    "EXAMEN DERMATOLÓGICO",
                    "FROTIS FARÍNGEO",
                    "GHQ12 (ANS/DEP)",
                    "HEMATOZOARIO, DENGUE Y CHAGAS",
                    "HISTORIA CLINICA ESPECIFICA AUDITIVA",
                    "HISTORIA CLINICA ESPECIFICA NUTRICIONAL",
                    "HISTORIA CLINICA ESPECIFICA OFTALMO",
                    "HISTORIA CLINICA ESPECIFICA RESPIRATORIA",
                    "HISTORIA CLINICA ESPECIFICA SALUD MENTAL",
                    "HISTORIA CLINICA ESPECIFICA TME",
                    "HOJA DE RETROALIMENTACIÓN",
                    "IMAGEN RXC",
                    "IMAGEN RXT",
                    "IMAGENES",
                    "INFORME",
                    "ISO TR 12295 1",
                    "ISO TR 12295 2",
                    "ISO TR 12295 3",
                    "ISO TR 12295 4",
                    "ISTAS 21",
                    "KOH de uñas",
                    "LABORATORIO CLÍNICO",
                    "LENTES DE SEGURIDAD",
                    "MAMOGRAFÍA",
                    "MAPA",
                    "MARCADORES BIOLÓGICOS",
                    "MEDICIÓN DE PLIEGUES CUTANEOS",
                    "OTROS",
                    "PAP TEST",
                    "PLAN DE EJERCICIOS",
                    "PLAN DESPARASITACIÓN INFANTIL",
                    "PLOMO EN SANGRE",
                    "PRESIÓN ARTERIAL",
                    "PRUEBA CUANTITATIVA SARS CoV2",
                    "PRUEBA PARCHE",
                    "PRUEBA PSICOLÓGICA PARA CHOFERES",
                    "PRUEBAS DE EQUILIBRIO",
                    "PRUEBAS FUNCIONALES HOMBRO",
                    "PRUEBAS FUNCIONALES MUÑECA",
                    "PRUEBAS FUNCIONALES COLUMNA",
                    "PRUEBAS TIROIDEAS",
                    "PSA",
                    "QUICK DASH",
                    "Q16",
                    "RADIOGRAFÍA DE TÓRAX (CRITERIOS DE LA OIT)",
                    "RAYOS X  COLUMNA DORSAL (AP Y LATERAL)",
                    "RAYOS X COLUMNA LUMBO-SACRA (AP Y LATERAL)",
                    "RAYOS X DE COLUMNA CERVICAL (AP Y LATERAL)",
                    "RAYOS X DE HOMBRO AP",
                    "RAYOS X DE HUESOS PROPIOS DE LA NARIZ",
                    "RAYOS X DE PELVIS",
                    "RAYOS X DE RODILLA",
                    "RAYOS X DE TOBILLO",
                    "RAYOS X DE TORAX",
                    "RAYOS X TORAX Y COLUMNA",
                    "RECETAS MEDICAS",
                    "RECOMENDACIONES EXTERNAS",
                    "REFRIGERIO",
                    "RESULTADOS VARIOS",
                    "RIESGO CARDIOVASCULAR",
                    "ROLAND MORRIS",
                    "RT - PCR",
                    "RX ABDOMINAL 2 POSICIONES",
                    "RX COLUMNA CERVICAL AP Y LATERAL",
                    "RX COLUMNA DORSAL AP Y LATERAL",
                    "RX COLUMNA DORSO LUMBAR APL",
                    "RX COLUMNA LUMBAR AP Y LATERAL",
                    "RX DE PELVIS",
                    "RX DE TORAX",
                    "RX PULGAR IZQUIERDO (AP Y LATERAL)",
                    "RX TORAX AP Y LATERAL",
                    "RX TORAX OIT",
                    "SUMA DE PLIEGUES",
                    "TAC DE NARÍZ Y SPN",
                    "TEST DALTONISMO",
                    "TEST DE DROGAS",
                    "TEST DE DROGAS EN ORINA",
                    "TEST DE ESFUERZO",
                    "TEST DE OSDI",
                    "TEST NÓRDICO",
                    "TEST POSTURAL",
                    "TEST POSTURAL CUESTIONARIO NORDICO ESTANDARIZADO",
                    "TEST PSICOLOGICO",
                    "TEST PSICOLÓGICOS PARA BRIGADISTAS",
                    "TEST WARTEGG",
                    "TIENE PRUEBAS FUNCIONALES HOMBRO",
                    "TIENE PRUEBAS FUNCIONALES MUÑECA",
                    "TIENE PRUEBAS FUNCIONALES COLUMNA",
                    "TIPO DE TRABAJO",
                    "TIPO DE CONDUCTA",
                    "TSH",
                    "UROLOGIA",
                    "VACUNA DT",
                    "VACUNA HEPATITIS AB",
                    "VACUNA INFLUENZA",
                    "VACUNAS",
                    "VALORACION  PLIBEL",
                    "VALORACIÓN DE CARDIOLOGÍA",
                    "VALORACIÓN FUNCIONAL",
                    "VALORACIÓN FUNCIONAL DE TME",
                    "VALORACION GINECO - OBSTETRICA",
                    "VALORACION NEUROLOGICA",
                    "VALORACIÓN ODONTÓLOGICA MAS PROFILAXIS",
                    "VALORACIÓN OFTALMOLÓGICA",
                    "VALORACIÓN DE ORL",
                    "VALORACIÓN PEDIÁTRICA",
                    "VALORACIÓN PSICOLÓGICA",
                    "VALORACIÓN TRAUMATOLOGICA",
                    "VIH",
                    "MSP MEDICAMENTO 1",
                    "MSP DOSIS 1",
                    "MSP MEDICAMENTO 2",
                    "MSP DOSIS 2",
                    "MSP MEDICAMENTO 3",
                    "MSP DOSIS 3",
                    "MSP MEDICAMENTO 4",
                    "MSP DOSIS 4",
                    "MSP MEDICAMENTO 5",
                    "MSP DOSIS 5",
                    "MSP ADICCIONES - TABACO - TIEMPO DE ABSTINENCIA",
                    "MSP ADICCIONES - ALCOHOL - TIEMPO DE CONSUMO",
                    "MSP ADICCIONES - ALCOHOL - EX CONSUMIDOR",
                    "MSP ADICCIONES - ALCOHOL - TIEMPO DE ABSTINENCIA",
                    "MSP ADICCIONES - DROGAS - TIEMPO DE CONSUMO",
                    "MSP ADICCIONES - DROGAS - CANTIDAD",
                    "MSP ADICCIONES - DROGAS - EX CONSUMIDOR",
                    "MSP ADICCIONES - DROGAS - TIEMPO DE ABSTINENCIA",
                    "MSP ACCIDENTES TRABAJO TIENE INCIDENTES",
                    "MSP ACCIDENTES TRABAJO INCIDENTE FECHA",
                    "MSP ACCIDENTES TRABAJO INCIDENTE DESCRIPCION",
                    "MSP ACCIDENTES TRABAJO TIENE ACCIDENTE",
                    "MSP ACCIDENTES TRABAJO ACCIDENTE FECHA",
                    "MSP ACCIDENTES TRABAJO ACCIDENTE DESCRIPCION",
                    "MSP ACCIDENTES TRABAJO CALIFICADO IESS",
                    "MSP ACCIDENTES TRABAJO CALIFICADO IESS FECHA",
                    "MSP ENFERMEDAD PROFESIONAL FECHA",
                    "MSP ENFERMEDAD PROFESIONAL CALIFICADO IESS",
                    "MSP ENFERMEDAD PROFESIONAL CALIFICADO IESS FECHA",
                    "MSP ENFERMEDAD METABÓLICA",
                    "MSP ENFERMEDAD METABÓLICA DESCRIPCION",
                    "MSP ENFERMEDAD NEUROLÓGICA",
                    "MSP ENFERMEDAD NEUROLÓGICA DESCRIPCION",
                    "MSP DISCAPACIDADES",
                    "MSP DISCAPACIDADES DESCRIPCION",
                    "MSP PIEL Y ANEXOS",
                    "MSP SATURACIÓN DE OXÍGENO",
                    "MSP CICATRICES",
                    "MSP CICATRICES DESCRIPCION",
                    "MSP TATUAJES",
                    "MSP TATUAJES DESCRIPCION",
                    "MSP PÁRPADOS",
                    "MSP PÁRPADOS DESCRIPCION",
                    "MSP CONJUNTIVAS",
                    "MSP CONJUNTIVAS DESCRIPCION",
                    "MSP PUPILAS",
                    "MSP PUPILAS DESCRIPCION",
                    "MSP CÓRNEA",
                    "MSP CÓRNEA DESCRIPCION",
                    "MSP MOTILIDAD",
                    "MSP MOTILIDAD DESCRIPCION",
                    "MSP AUDITIVO EXTERNO",
                    "MSP AUDITIVO EXTERNO DESCRIPCION",
                    "MSP PABELLÓN",
                    "MSP PABELLÓN DESCRIPCION",
                    "MSP TÍMPANOS",
                    "MSP TÍMPANOS DESCRIPCION",
                    "MSP LABIOS",
                    "MSP LABIOS DESCRIPCION",
                    "MSP LENGUA",
                    "MSP LENGUA DESCRIPCION",
                    "MSP FARINGE",
                    "MSP FARINGE DESCRIPCION",
                    "MSP AMÍGDALAS",
                    "MSP AMÍGDALAS DESCRIPCION",
                    "MSP DENTADURA",
                    "MSP DENTADURA DESCRIPCION",
                    "MSP TABIQUE",
                    "MSP TABIQUE DESCRIPCION",
                    "MSP CORNETES",
                    "MSP CORNETES DESCRIPCION",
                    "MSP MUCOSAS",
                    "MSP MUCOSAS DESCRIPCION",
                    "MSP SENOS PARANASALES",
                    "MSP SENOS PARANASALES DESCRIPCION",
                    "MSP TIROIDES / MASAS",
                    "MSP TIROIDES / MASAS DESCRIPCION",
                    "MSP MOVILIDAD",
                    "MSP MOVILIDAD DESCRIPCION",
                    "MSP MAMAS",
                    "MSP MAMAS DESCRIPCION",
                    "MSP CORAZÓN",
                    "MSP CORAZÓN DESCRIPCION",
                    "MSP PULMONES",
                    "MSP PULMONES DESCRIPCION",
                    "MSP PARRILLA COSTAL",
                    "MSP PARRILLA COSTAL DESCRIPCION",
                    "MSP VÍSCERAS",
                    "MSP VÍSCERAS DESCRIPCION",
                    "MSP PARED ABDOMINAL",
                    "MSP PARED ABDOMINAL DESCRIPCION",
                    "MSP FLEXIBILIDAD",
                    "MSP FLEXIBILIDAD DESCRIPCION",
                    "MSP DESVIACIÓN",
                    "MSP DESVIACIÓN DESCRIPCION",
                    "MSP DOLOR",
                    "MSP DOLOR DESCRIPCION",
                    "MSP PELVIS",
                    "MSP PELVIS DESCRIPCION",
                    "MSP GENITALES",
                    "MSP GENITALES DESCRIPCION",
                    "MSP VASCULAR",
                    "MSP VASCULAR DESCRIPCION",
                    "MSP MIEMBROS SUPERIORES",
                    "MSP MIEMBROS SUPERIORES DESCRIPCION",
                    "MSP MIEMBROS INFERIORES",
                    "MSP MIEMBROS INFERIORES DESCRIPCION",
                    "MSP FUERZA",
                    "MSP FUERZA DESCRIPCION",
                    "MSP SENSIBILIDAD",
                    "MSP SENSIBILIDAD DESCRIPCION",
                    "MSP MARCHA",
                    "MSP MARCHA DESCRIPCION",
                    "MSP REFLEJOS",
                    "MSP REFLEJOS DESCRIPCION",
                    "MSP CODIGO MEDICO",
                    "A MOL 3M CUE",
                    "A MOL 3M HD",
                    "A MOL 3M HI",
                    "A MOL 3M ESPAL",
                    "A MOL 3M MSD",
                    "A MOL 3M MSI",
                    "A MOL 3M MD",
                    "A MOL 3M MI",
                    "B1 TIEMPO MOLEST CUE",
                    "B1 TIEMPO MOLEST HD",
                    "B1 TIEMPO MOLEST HI",
                    "B1 TIEMPO MOLEST ESPAL",
                    "B1 TIEMPO MOLEST MSD",
                    "B1 TIEMPO MOLEST MSI",
                    "B1 TIEMPO MOLEST MD",
                    "B1 TIEMPO MOLEST MI",
                    "B2 CAMB PT CUE",
                    "B2 CAMB PT HD",
                    "B2 CAMB PT HI",
                    "B2 CAMB PT ESPAL",
                    "B2 CAMB PT MSD",
                    "B2 CAMB PT MSI",
                    "B2 CAMB PT MD",
                    "B2 CAMB PT MI",
                    "B3 DURA MOL CUE",
                    "B3 DURA MOL HD",
                    "B3 DURA MOL HI",
                    "B3 DURA MOL ESPAL",
                    "B3 DURA MOL MSD",
                    "B3 DURA MOL MSI",
                    "B3 DURA MOL MD",
                    "B3 DURA MOL MI",
                    "B4 DUR EPI CUE",
                    "B4 DUR EPI HD",
                    "B4 DUR EPI HI",
                    "B4 DUR EPI ESPAL",
                    "B4 DUR EPI MSD",
                    "B4 DUR EPI MSI",
                    "B4 DUR EPI MD",
                    "B4 DUR EPI MI",
                    "B5 INCAP CUE",
                    "B5 INCAP HD",
                    "B5 INCAP HI",
                    "B5 INCAP ESPAL",
                    "B5 INCAP MSD",
                    "B5 INCAP MSI",
                    "B5 INCAP MD",
                    "B5 INCAP MI",
                    "B6 TTO CUE",
                    "B6 TTO HD",
                    "B6 TTO HI",
                    "B6 TTO ESPAL",
                    "B6 TTO MSD",
                    "B6 TTO MSI",
                    "B6 TTO MD",
                    "B6 TTO MI",
                    "C1 MOL 7 DIAS CUE",
                    "C1 MOL 7 DIAS HD",
                    "C1 MOL 7 DIAS HI",
                    "C1 MOL 7 DIAS ESPAL",
                    "C1 MOL 7 DIAS MSD",
                    "C1 MOL 7 DIAS MSI",
                    "C1 MOL 7 DIAS MD",
                    "C1 MOL 7 DIAS MI",
                    "C2 INTEN CUE",
                    "C2 INTEN HD",
                    "C2 INTEN HI",
                    "C2 INTEN ESPAL",
                    "C2 INTEN MSD",
                    "C2 INTEN MSI",
                    "C2 INTEN MD",
                    "C2 INTEN MI",
                    "C3 INCAP CUE",
                    "C3 INCAP HD",
                    "C3 INCAP HI",
                    "C3 INCAP ESPAL",
                    "C3 INCAP MSD",
                    "C3 INCAP MSI",
                    "C3 INCAP MD",
                    "C3 INCAP MI"

                ],
                dataExport: [],

            }
        },
        methods: {
            getDataByIdCliente(idCliente) {
                this.$store.dispatch('getCompanyAgenciesByCompany', idCliente).then(
                    response => {
                        let companyAll = {id: 'TODOS', name: 'TODOS'}
                        this.$store.state.companyAgencies.push(companyAll)
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                )
                this.$store.dispatch('getCompanyJobsByCompany', idCliente).then(
                    response => {
                        let companyAll = {id: 'TODOS', name: 'TODOS'}
                        this.$store.state.companyJobs.push(companyAll)
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                )
            },
            newConfiguration() {
                this.$store.dispatch('getExportProcessConfiguration').then(
                    response => {
                        console.log(response.data)
                        if (response.data != null && response.data.length > 0) {
                            this.dataExport = JSON.parse(response.data[0].value);
                            this.idConfiguration = response.data[0].id
                        } else {
                            this.resetValuesConfiguration()
                        }
                        this.dialog = true
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                )
            },
            saveConfiguration() {
                if (this.idConfiguration != "" && this.idConfiguration != null) {
                    this.$store.dispatch('updateExportProcessConfiguration', {id:this.idConfiguration,value: JSON.stringify(this.dataExport)}).then(
                        response => {
                            if (response.data != null && response.data.length > 0) {
                                this.idConfiguration = response.data[0].id
                                this.dataExport = response.data;
                            } else {
                                this.resetValuesConfiguration()
                            }
                            this.dialog = false
                        },
                        error => {
                            this.$store.state.dialogError = true;
                        }
                    )
                } else {
                    this.$store.dispatch('addExportProcessConfiguration', {value: JSON.stringify(this.dataExport)}).then(
                        response => {
                            if (response.data != null && response.data.length > 0) {
                                this.dataExport = response.data;
                                this.idConfiguration = response.data[0].id
                            } else {
                                this.resetValuesConfiguration()
                            }
                            this.dialog = false
                        },
                        error => {
                            this.$store.state.dialogError = true;
                        }
                    )
                }

            },
            resetValuesConfiguration() {
                this.dataExport = []
                for (let i = 0; i < this.campos.length; i++) {
                    let data = {id: i, name: this.campos[i], newName: "", selected: true}
                    this.dataExport.push(data)

                }

            },
            save() {
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('getExportProcessConfiguration').then(
                        response => {
                            if (response.data != null && response.data.length > 0) {
                                this.idConfiguration = response.data[0].id
                                this.dataExport = JSON.parse(response.data[0].value);
                            } else {
                                this.resetValuesConfiguration()
                            }
                            var exportProcess = {};
                            exportProcess.idCliente = {id: this.idCliente};
                            exportProcess.idTipoExamen = this.idTipoExamen;
                            exportProcess.fechaInicio = this.fechaInicio;
                            exportProcess.fechaFin = this.fechaFin;
                            exportProcess.configuration = JSON.stringify(this.dataExport)
                            if (this.idAgencia != 'TODOS') {
                                exportProcess.idAgencia = {id: this.idAgencia};
                            }
                            if (this.idPuestoTrabajo != 'TODOS') {
                                exportProcess.idPuestoTrabajo = {id: this.idPuestoTrabajo};
                            }
                            exportProcess.usuarioCreacion = this.$store.state.idUser;
                            this.$store.dispatch('addExportProcess', exportProcess).then(response => {
                                this.dialogSuccess = true
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                            this.alert = true;
                            this.$refs.form.reset();
                            this.$vuetify.goTo(0);
                        },
                        error => {
                            this.$store.state.dialogError = true;
                        }
                    )
                }
            }
        },
        watch: {
            idCliente: function (val) {
                if (val != null && val != undefined) {
                    this.getDataByIdCliente(val);
                }
            }
        },
        beforeCreate() {
            this.$store.dispatch('getCompanies').then(response => {
            }, error => {
                this.$store.state.dialogError = true
            })
        },
        created() {
            this.$store.dispatch('getExportProcessConfiguration').then(
                response => {
                    if (response.data != null && response.data.length > 0) {
                        this.idConfiguration = response.data[0].id
                        this.dataExport = JSON.parse(response.data[0].value);
                    } else {
                        this.resetValuesConfiguration()
                    }
                },
                error => {
                    this.$store.state.dialogError = true;
                }
            )
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/exportProcess/ExportProcess.vue